export type LegalLanguage = 'pl' | 'en';

function normalizeLanguage(lang?: string): LegalLanguage {
  if (!lang) return 'pl';
  return lang.toLowerCase().startsWith('pl') ? 'pl' : 'en';
}

export function resolvePrivacyPdfPath(lang?: string): string {
  const normalized = normalizeLanguage(lang);
  return `/legal/privacy-policy-${normalized}.pdf`;
}

export function resolveTermsPdfPath(lang?: string): string {
  const normalized = normalizeLanguage(lang);
  return `/legal/terms-of-service-${normalized}.pdf`;
}

export function resolveCookiePolicyPdfPath(lang?: string): string {
  const normalized = normalizeLanguage(lang);
  return `/legal/cookie-policy-${normalized}.pdf`;
}

export function resolveNoticeAtCollectionPdfPath(lang?: string): string {
  const normalized = normalizeLanguage(lang);
  return `/legal/notice-at-collection-${normalized}.pdf`;
}

export const privacyPdfPath = resolvePrivacyPdfPath('pl');
export const termsPdfPath = resolveTermsPdfPath('pl');
